const theme = {
   light: {
      browserNotCompatibleView: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600'
      },
      crossBrowserBanner: {
         textStyles: 'text-gray-700',
         bannerBgColor: 'bg-warning-50'
      }
   },
   dark: {}
}

export default theme
